<template>
  <v-card style="text-align: center" flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="d-flex justify-space-between align-center pa-0 ma-0">
          <div class="ml-2">
            <v-btn outlined icon class="ma-2" color="primary" @click.native="playing ? pause() : play()" :disabled="!loaded">
              <v-icon v-if="!playing || paused">mdi-play</v-icon>
              <v-icon v-else>mdi-pause</v-icon>
            </v-btn>
          </div>

          <div style="flex-grow: 1" class="mx-2 mb-2 d-flex flex-column justify-center">
            <v-progress-linear v-model="percentage" height="5" style="margin-top: 15px; margin-bottom: 15px;" @click.native="setPosition()" :disabled="!loaded"></v-progress-linear>
            <p class="ma-0">{{ currentTime }} / {{ duration }}</p>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
    <video style="display: none;" ref="player" :src="file" type="video/mp4"></video>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';

const formatTime = second => new Date(second * 1000).toISOString().substr(14, 5);

export default {
  name: "AudioPlayer",

  props: {
    file: {
      type: String,
      default: null
    },
  },

  data() {
    return {
      firstPlay: true,
      loaded: false,
      playing: false,
      paused: false,
      percentage: 0,
      currentTime: '00:00',
      audio: undefined,
      totalDuration: 0,
      playerVolume: 0.8
    }
  },

  computed: {
    duration: function () {
      return this.audio ? formatTime(this.totalDuration) : ''
    },

    ...mapState([
    ]),
  },

  mounted () {
    this.audio = this.$refs.player;
    this.init();
  },

  beforeDestroy () {
    this.audio.removeEventListener('timeupdate', this._handlePlayingUI)
    this.audio.removeEventListener('loadeddata', this._handleLoaded)
    this.audio.removeEventListener('pause', this._handlePlayPause)
    this.audio.removeEventListener('play', this._handlePlayPause)
    this.audio.removeEventListener('ended', this._handleEnded);
  },

  methods: {
    setPosition () {
      this.audio.currentTime = parseInt(this.audio.duration / 100 * this.percentage);
    },
    stop () {
      this.audio.pause()
      this.paused = true
      this.playing = false
      this.audio.currentTime = 0
    },
    play () {
      if (this.playing) return
      this.audio.play().then(() => this.playing = true)
      this.paused = false
    },
    pause () {
      this.paused = !this.paused;
      (this.paused) ? this.audio.pause() : this.audio.play()
    },

    _handleLoaded: function () {
      if (this.audio.readyState >= 2) {
        if (this.audio.duration === Infinity) {
          this.audio.currentTime = 1e101;
          this.audio.ontimeupdate = () => {
            this.audio.ontimeupdate = () => {}
            this.audio.currentTime = 0
            this.totalDuration = parseInt(this.audio.duration)
            this.loaded = true;
          }
        } else {
          this.totalDuration = parseInt(this.audio.duration)
          this.loaded = true
        }
        // if (this.autoPlay) this.audio.play()
      } else {
        throw new Error('Failed to load audio file')
      }
    },
    _handlePlayingUI: function () {
      this.audio.volume = this.playerVolume
      this.percentage = this.audio.currentTime / this.audio.duration * 100
      this.currentTime = formatTime(this.audio.currentTime)
      this.playing = true
    },
    _handlePlayPause: function (e) {
      if (e.type === 'play' && this.firstPlay) {
        this.audio.currentTime = 0;
        if (this.firstPlay) {
            this.firstPlay = false;
        }
      }
      if (e.type === 'pause' && this.paused === false && this.playing === false) {
        this.currentTime = '00:00'
      }
    },
    _handleEnded () {
      this.paused = this.playing = false;
    },
    init: function () {
      this.audio.addEventListener('timeupdate', this._handlePlayingUI);
      this.audio.addEventListener('loadeddata', this._handleLoaded);
      this.audio.addEventListener('pause', this._handlePlayPause);
      this.audio.addEventListener('play', this._handlePlayPause);
      this.audio.addEventListener('ended', this._handleEnded);
    },
  }
}
</script>

<style scoped>
</style>